// TIDAK TERPAKAI — komponen pendukung V1: hanya dipakai oleh halaman V1 (frontend/src/pages/) dan/atau AppShell.jsx (V1), yang keduanya tidak terjangkau sejak App.js mengarahkan semua rute ke V2App. Jangan diedit. Lihat memory/DEPRECATED.md.
// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE
// version  : 1.0
// updated  : 2026-06-15
// replaces : -
// protected: NO  -> Tambahkan riwayat di /app/memory CHANGELOG saat diubah.
// =============================================================================

import React from "react";
import { useRealtime } from "@/context/RealtimeContext";
import { Wifi, WifiOff, Loader2 } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const LiveStatus = () => {
  const rt = useRealtime();
  const status = rt?.status || "offline";

  const cfg = {
    live: {
      label: "Live",
      icon: Wifi,
      dot: "bg-[hsl(var(--status-approved))]",
      text: "text-[hsl(var(--status-approved))]",
      tip: "Data diperbarui otomatis secara real-time",
    },
    connecting: {
      label: "Menyambung",
      icon: Loader2,
      dot: "bg-[hsl(var(--status-waiting))]",
      text: "text-[hsl(var(--status-waiting))]",
      tip: "Sedang menyambungkan ke server real-time...",
    },
    offline: {
      label: "Offline",
      icon: WifiOff,
      dot: "bg-muted-foreground",
      text: "text-muted-foreground",
      tip: "Koneksi real-time terputus. Akan mencoba menyambung kembali.",
    },
  }[status];

  const Icon = cfg.icon;

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            data-testid="realtime-status-indicator"
            data-status={status}
            className={`flex items-center gap-1.5 rounded-full border border-border bg-card px-2.5 py-1 ${cfg.text}`}
          >
            <span className="relative flex h-2 w-2">
              {status === "live" && (
                <span className={`absolute inline-flex h-full w-full animate-ping rounded-full ${cfg.dot} opacity-60`} />
              )}
              <span className={`relative inline-flex h-2 w-2 rounded-full ${cfg.dot}`} />
            </span>
            <Icon className={`w-3.5 h-3.5 ${status === "connecting" ? "animate-spin" : ""}`} />
            <span className="text-xs font-medium hidden sm:inline">{cfg.label}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>{cfg.tip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
